import Vue from "vue";
import router from "./router";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./style.css";
import App from "./App.vue";
import EventBus from "./eventbus";
import { LOGOUT } from "./event";
import swal from "sweetalert";

const base = axios.create({
  baseURL: process.env.VUE_APP_BASE_URI,
});

// Add a response interceptor
base.interceptors.response.use(
  function (response) {
    // If the request is successful, just return the response
    return response;
  },
  function (error) {
    // Check if the error has a specific status code
    if (error.response && error.response.status === 401) {
      swal("Error", "Login expired", "error");
      EventBus.$emit(LOGOUT);
    }

    // Optionally handle other specific status codes if needed
    // if (error.response.status === 500) {
    //   console.log('Server error');
    // }

    // Always return the error, you can choose to throw it or handle it gracefully
    return Promise.reject(error);
  }
);

Vue.prototype.$http = base;
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
